// src/components/RPA/ui/SidePanel.js
import React, { useEffect } from 'react';

const overlay = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 50
};
const panel = {
  position: 'fixed', top: 0, right: 0, height: '100vh', width: 480,
  maxWidth: '100%', background: '#fff', boxShadow: '0 0 24px rgba(0,0,0,0.2)',
  zIndex: 60, display: 'flex', flexDirection: 'column'
};

export default function SidePanel({ isOpen, title, onClose, children }) {
  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') onClose?.(); };
    if (isOpen) window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;
  return (
    <>
      <div style={overlay} onClick={onClose} />
      <div style={panel} role="dialog" aria-modal="true">
        <div style={{ padding: 12, borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <strong style={{ fontSize: 16 }}>{title}</strong>
          <button onClick={onClose} style={{ background: 'transparent', border: 0, fontSize: 14, color: '#6b7280', cursor: 'pointer' }}>✕</button>
        </div>
        <div style={{ padding: 12, overflowY: 'auto', flex: 1 }}>
          {children}
        </div>
      </div>
    </>
  );
}
